import React from 'react';
import SectionContainer from '../../../common/SectionContainer';
import FieldRow from '../../../common/FieldRow';
import {
  baseImponible as biFn,
} from '../formulas';

const BaseImponibleSection = ({ data, computed }) => {
  const comp = computed.baseImponible || {};
  const bi = biFn;

  return (
    <SectionContainer title="Base Imponible y Art. 14 letra E)" subtitle="Determinación de la Base Imponible de Primera Categoría">
      {/* Ingresos */}
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Ingresos del Ejercicio</h4>
        <FieldRow label="Ventas netas a entidades NO relacionadas" code="1400" sign="(+)"
          value={bi.ventasNoRelacionadas(data)} computed />
        <FieldRow label="Ventas a entidades relacionadas (14A)" code="1587" sign="(+)"
          value={bi.ventasRelacionadas14A(data)} computed />
        <FieldRow label="Ingresos devengados en 2024 y percibidos en 2025" code="1817" sign="(+)"
          value={bi.ingresosDevengadosPercibidos(data)} computed />
        <FieldRow label="Total ingresos del giro" sign="(=)" value={comp.totalIngresosGiro} computed className="f22-field-subtotal" />

        <FieldRow label="Dividendo de fuente extranjera, percibido" code="1401" sign="(+)"
          value={bi.dividendoFuenteExtranjera(data)} computed />
        <FieldRow label="CTD determinado" code="1401" sign="(+)"
          value={bi.ctdDeterminado(data)} computed />
        <FieldRow label="Total ingresos de fuente extranjera" sign="(=)" value={comp.totalIngresosFuenteExtranjera} computed className="f22-field-subtotal" />

        <FieldRow label="Ingresos netos por venta computador" code="1588" sign="(+)"
          value={bi.ingresosVentaComputador(data)} computed />
        <FieldRow label="Reajuste PPM Pagados" code="1588" sign="(+)"
          value={bi.reajustePPM(data)} computed />
        <FieldRow label="Total otros ingresos" sign="(=)" value={comp.totalOtrosIngresos} computed className="f22-field-subtotal" />

        <FieldRow label="Total ingresos" sign="(=)" value={comp.totalIngresos} computed className="f22-field-highlight" />
      </div>

      {/* Egresos */}
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Egresos del Ejercicio</h4>
        <FieldRow label="Compras netas existencias 2025" code="1409" sign="(-)"
          value={bi.comprasNetas(data)} computed />
        <FieldRow label="Gastos adeudados en 2024 y pagados en 2025" code="1818" sign="(-)"
          value={bi.gastosAdeudados2024Pagados(data)} computed />
        <FieldRow label="Compra neta camioneta de reparto" code="1413" sign="(-)"
          value={bi.compraCamioneta(data)} computed />
        <FieldRow label="Remuneraciones del ejercicio, monto bruto" code="1411" sign="(-)"
          value={bi.remuneraciones(data)} computed />
        <FieldRow label="Honorarios del ejercicio, monto bruto" code="1412" sign="(-)"
          value={bi.honorarios(data)} computed />
        <FieldRow label="Gastos generales" code="1424" sign="(-)"
          value={bi.gastosGenerales(data)} computed />
        <FieldRow label="Arriendos" code="1415" sign="(-)"
          value={bi.arriendos(data)} computed />
        <FieldRow label="Interés por préstamo" code="1419" sign="(-)"
          value={bi.interesesPrestamo(data)} computed />
        <FieldRow label="Pago intereses y multas fiscales" code="1422" sign="(-)"
          value={bi.pagoInteresesMultas(data)} computed />
        <FieldRow label="Pago IDPC AT 2025" code="1422" sign="(-)"
          value={bi.pagoIDPC(data)} computed />
        <FieldRow label="Total egresos del giro" sign="(=)" value={comp.totalEgresosGiro} computed className="f22-field-subtotal" />
      </div>

      {/* Gastos rechazados */}
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Gastos rechazados Art. 21 LIR</h4>
        <FieldRow label="Pago intereses y multas fiscales" code="1431" sign="(+)"
          value={bi.gastosRechazadosIntereses(data)} computed />
        <FieldRow label="Pago IDPC AT 2025" code="1431" sign="(+)"
          value={bi.gastosRechazadosIDPC(data)} computed />
        <FieldRow label="Total gastos rechazados" sign="(=)" value={comp.totalGastosRechazados} computed className="f22-field-subtotal" />
      </div>

      {/* BI e incentivo */}
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Base Imponible e Incentivo al Ahorro</h4>
        <FieldRow label="Base Imponible antes de incentivo al ahorro" sign="(=)"
          value={comp.baseImponibleAntesIncentivo} computed className="f22-field-highlight" />
        <FieldRow label="Deducción incentivo al ahorro art. 14 letra E)" code="1432" sign="(-)"
          value={comp.incentivoAhorro} computed />
        <FieldRow label="BASE IMPONIBLE IDPC" sign="(=)"
          value={comp.baseImponibleIDPC} computed className="f22-field-total" />
        <FieldRow label={`IDPC (tasa ${data.antecedentes.tasaIDPC * 100}%)`} sign="(=)"
          value={comp.idpc} computed className="f22-field-total" />
      </div>

      {/* Detalle incentivo */}
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Determinación incentivo al ahorro (art.14 letra E) LIR)</h4>
        <FieldRow label="Sub total Base Imponible" sign="(=)"
          value={comp.baseImponibleAntesIncentivo} computed />
        <FieldRow label="Retiros del ejercicio, históricos" sign="(-)"
          value={-(computed.antecedentes?.totalRetirosHistorico || 0)} computed />
        <FieldRow label="Intereses y multas fiscales, históricos" sign="(-)"
          value={-(data.antecedentes.pagoInteresesMultas || 0)} computed />
        <FieldRow label="Pago IDPC AT 2025, histórico" sign="(-)"
          value={-(data.antecedentes.pagoIDPCAT2025 || 0)} computed />
        <FieldRow label="BI Invertida" sign="(=)"
          value={biFn.biInvertida(data)} computed className="f22-field-subtotal" />
        <FieldRow label="Incentivo al ahorro (menor entre 50% BI Invertida o 5.000 UF)"
          value={comp.incentivoAhorro} computed className="f22-field-highlight" />
      </div>
    </SectionContainer>
  );
};

export default BaseImponibleSection;
